import React, { useEffect, useRef } from 'react'
import $ from 'jquery'
import 'datatables.net-bs4'
import 'datatables.net-bs4/css/dataTables.bootstrap4.min.css'
import 'bootstrap/dist/css/bootstrap.min.css'
import { Link } from 'react-router-dom';
import './../../App.css';

const activitiesinitialData = [
  { srNo: 1, startDate: "2011/04/25", name: "Tiger Nixon", service:"Pan Application", acknowledgementNo: 101, dwnbtn: "btn", editbtn: "btn" },
  { srNo: 2, startDate: "2011/07/25", name: "Garrett Winters", service:" Publication Name", acknowledgementNo: 102, dwnbtn: "btn", editbtn: "btn" },
  { srNo: 3, startDate: "2011/04/25", name: "Nixon Tiger ", service:"New Application", acknowledgementNo: 103, dwnbtn: "btn", editbtn: "btn"  },
  { srNo: 4, startDate: "2011/07/25", name: " Winters Garrett", service:"Correction Pan Application", acknowledgementNo: 104, dwnbtn: "btn", editbtn: "btn" }
]
const Activities = () => {
  const tableRef = useRef(null)
  useEffect(() => {
    if (tableRef.current) {
      const table = $(tableRef.current).DataTable({
        data: activitiesinitialData,
        columns: [
          { data: 'srNo', title: 'Sr No' },
          { data: 'startDate', title: 'Date' },
          { data: 'name', title: 'Name' },
          { data: 'service', title: 'Services' },
          { data: 'acknowledgementNo', title: 'Acknowledgement No' },
          { data: 'dwnbtn', title: 'Download', render: (data, type, row) => {
            return `
             <button className="btn" data-id="${row.srNo}">
                  Download  <i className="mdi mdi-download"></i>
              </button>
             
            `;
          } 
        },
        {
          data: 'editbtn',
          title: 'Edit',
          render: (data, type, row) => {
            return `
              <button className="btn edit-btn" data-id="${row.srNo}">
                Edit <i className="mdi mdi-edit"></i>
              </button>
            `;
          }
        }
        ],
        initComplete: function () {
          this.api().columns().every(function () {
            const column = this
            const select = $('<select className="form-control"><option value=""></option></select>')
              .appendTo($(column.footer()).empty())
              .on('change', function () {
                const val = $.fn.dataTable.util.escapeRegex(
                  $(this).val()
                )

                column
                  .search(val ? '^' + val + '$' : '', true, false)
                  .draw()
              })

            column.data().unique().sort().each(function (d, j) {
              select.append('<option value="' + d + '">' + d + '</option>')
            })
          })
        }
      })

      // Add event listener for the download button
    $('#productsTable').on('click', '.download-btn', function () {
      const srNo = $(this).data('id');
      console.log('Download button clicked for Sr No:', srNo);
      // Add your download logic here
      alert(`Downloading data for Sr No: ${srNo}`);
    });

      return () => {
        table.destroy()
      }
    }
  }, [])
  return (
   <>
    <div className="content-wrapper">
      <div className="content">
        <div className="card card-default card-profile">
          <div className="card-body card-profile-body">
            <div className="profile-avata text-center">
              <span className="h5 d-block mt-3 mb-2">Albrecht Straub</span>
              <span className="d-block">Albrecht.straub@gmail.com</span>
            </div>
          </div>
          <div className="card-footer card-profile-footer">
            <ul className="nav nav-border-top justify-content-center">
              <li className="nav-item">
                <Link className="nav-link active" to="/dashboard/activities">Activities</Link>
              </li>
              <li className="nav-item">
                <Link className="nav-link " to="/dashboard/user-profile">Edit profile</Link>
              </li>             
            </ul>              
          </div>
        </div>
        <div className="row mb-4 mt-4">
          <div className="col-xl-2 col-md-6">
            <div className="card card-default">
              <div className="p-1">
                <div className="icon-md bg-secondary rounded-circle mr-1">
                  <i className="mdi mdi-account-plus-outline"></i>
                </div>
                <div className="text-center">
                  <span className="h2 d-block">890</span>
                  <p>CAMP Registration</p>
                </div>
              </div>
            </div>
          </div>
          <div className="col-xl-2 col-md-6">
            <div className="card card-default">
              <div className="p-1">
                <div className="icon-md bg-success rounded-circle mr-1">
                  <i className="mdi mdi-account-plus-outline"></i>
                </div>
                <div className="text-center">
                  <span className="h2 d-block">350</span>
                  <p>Correction PAN App</p>
                </div>
              </div>
            </div>
          </div>
          <div className="col-xl-2 col-md-6">
            <div className="card card-default">
              <div className="p-1">
                <div className="icon-md bg-primary rounded-circle mr-1">
                  <i className="mdi mdi-account-plus-outline"></i>
                </div>
                <div className="text-center">
                  <span className="h2 d-block">1360</span>
                  <p>Deiclation For Publication</p>
                </div>
              </div>
            </div>
          </div>
          <div className="col-xl-2 col-md-6">
            <div className="card card-default">
              <div className="p-1">
                <div className="icon-md bg-info rounded-circle mr-1">
                  <i className="mdi mdi-account-plus-outline"></i>
                </div>
                <div className="text-center">
                  <span className="h2 d-block">8930</span>
                  <p>Name Publication</p>
                </div>
              </div>
            </div>
          </div>
            <div className="col-xl-2 col-md-6">
            <div className="card card-default">
              <div className="p-1">
                <div className="icon-md bg-info rounded-circle mr-1">
                  <i className="mdi mdi-account-plus-outline"></i>
                </div>
                <div className="text-center">
                  <span className="h2 d-block">8930</span>
                  <p>PAN Object</p>
                </div>
              </div>
            </div>
          </div>
            <div className="col-xl-2 col-md-6">
            <div className="card card-default">
              <div className="p-1">
                <div className="icon-md bg-info rounded-circle mr-1">
                  <i className="mdi mdi-account-plus-outline"></i>
                </div>
                <div className="text-center">
                  <span className="h2 d-block">8930</span>
                  <p>New PAN Application</p>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="row">
          <div className="col-lg-12">
            <div className="card card-default">
              <div className="card-header">
                <h2>Service status</h2>
              </div> 
              <div className="card-body">    
                <table ref={tableRef} id="productsTable" className="table table-bordered table-hover table-product" style={{ width: '100%' }}>
                  <thead>
                    <tr>
                      <th>Sr. No.</th>
                      <th>Date</th>
                      <th>Name</th>
                      <th>Acknowledgement No</th>
                      <th>Service</th>
                      <th>Download</th>
                      <th>Edit</th>
                    </tr>
                  </thead>
                  {/* <tfoot>
                    <tr>
                      <th>Sr No</th>
                      <th>Date</th>
                      <th>Name</th>
                      <th>Acknowledgement No</th>
                      <th>Status</th>
                    </tr>
                  </tfoot> */}
                </table>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>               
                      
   </>
  );
};

export default Activities;
